/* drye-layer-mechanism.js — the DRYE layer opens and reveals its two faces.

   Standalone on purpose so the section can be dropped on any template without
   touching drye-hockey-lp.js. If you would rather keep one shared file, lift
   layers() into that IIFE next to the other init functions and add layers(t)
   to the init list; nothing else has to change.

   The reveal is CUMULATIVE and runs ONCE. Each beat adds to what is already on
   screen and the last one holds — a loop would rewind the argument just as it
   lands. The clock does not start until the section is actually on screen, so
   a reader who scrolls past never misses beat one. */
(function () {
  if (window.DRYELayers) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Beat 1 is shorter: nothing moves in it, it is only the two faces arriving. */
  var BEAT_1 = 2200;
  var BEAT_2 = 3400;

  function layers(scope) {
    scope.querySelectorAll('[data-drye-layers]:not([data-drye-layers-bound])').forEach(function (root) {
      root.setAttribute('data-drye-layers-bound', '1');

      var trigger = root.querySelector('[data-drye-layers-open]');
      var panelwrap = root.querySelector('[data-drye-layers-panelwrap]');
      var panel = root.querySelector('[data-drye-layers-panel]');
      var closeBtn = root.querySelector('[data-drye-layers-close]');
      var presscue = root.querySelector('[data-drye-layers-presscue]');
      if (!trigger || !panel) return;

      var dryePane = root.querySelector('[data-drye-layers-pane="drye"]');
      var cottonPane = root.querySelector('[data-drye-layers-pane="cotton"]');
      var headDrye = root.querySelector('[data-drye-layers-head="drye"]');
      var headCotton = root.querySelector('[data-drye-layers-head="cotton"]');
      var dots = root.querySelector('[data-drye-layers-dots]');
      var compare = root.querySelector('[data-drye-layers-compare]');
      var btnDrye = root.querySelector('[data-drye-layers-pick="drye"]');
      var btnCotton = root.querySelector('[data-drye-layers-pick="cotton"]');

      var arrowsUp = root.querySelector('[data-drye-layers-arrows="up"]');
      var arrowsDown = root.querySelector('[data-drye-layers-arrows="down"]');
      var skinCalm = root.querySelector('[data-drye-layers-skin="calm"]');
      var skinRisk = root.querySelector('[data-drye-layers-skin="risk"]');
      var topArrows = root.querySelector('[data-drye-layers-toparrows]');
      var topSpacer = root.querySelector('[data-drye-layers-topspacer]');

      var cals = {
        knit: root.querySelector('[data-drye-layers-cal="knit"]'),
        cross: root.querySelector('[data-drye-layers-cal="cross"]'),
        spread: root.querySelector('[data-drye-layers-cal="spread"]')
      };

      var open = false;
      var material = 'drye';
      var step = 1;
      var t1 = null;
      var t2 = null;
      var onscreen = false;
      var pending = false;

      function show(el, on) { if (el) el.hidden = !on; }

      function paint() {
        var cotton = material === 'cotton';

        show(panelwrap, !open);
        show(panel, open);
        show(presscue, !open);
        show(compare, open);

        show(headDrye, !cotton);
        show(headCotton, cotton);
        show(dryePane, open && !cotton);
        show(cottonPane, open && cotton);
        show(dots, open && !cotton);

        /* When the layer is open the droplets inside carry the direction; the
           outer arrows would only repeat it, more weakly. */
        show(topArrows, !open);
        show(topSpacer, open);

        /* Cotton reverses the lower half: nothing leaves, so it goes back down. */
        var trapped = open && cotton;
        show(arrowsUp, !trapped);
        show(arrowsDown, trapped);
        show(skinCalm, !trapped);
        show(skinRisk, trapped);

        if (btnDrye) btnDrye.classList.toggle('is-on', !cotton);
        if (btnCotton) btnCotton.classList.toggle('is-on', cotton);
        if (btnDrye) btnDrye.setAttribute('aria-pressed', String(!cotton));
        if (btnCotton) btnCotton.setAttribute('aria-pressed', String(cotton));

        show(cals.knit, open && !cotton && step >= 1);
        show(cals.cross, open && !cotton && step >= 2);
        show(cals.spread, open && !cotton && step >= 3);

        var drops = root.querySelector('[data-drye-layers-drops]');
        var pool = root.querySelector('[data-drye-layers-pool]');
        show(drops, open && !cotton && step >= 2);
        show(pool, open && !cotton && step >= 3);

        if (dots) {
          Array.prototype.forEach.call(dots.children, function (dot, i) {
            dot.classList.toggle('is-on', step >= i + 1);
          });
        }

        trigger.setAttribute('aria-expanded', String(open));
      }

      function stopSeq() {
        clearTimeout(t1);
        clearTimeout(t2);
        t1 = t2 = null;
        pending = false;
      }

      function startSeq() {
        stopSeq();
        step = 1;
        paint();

        /* Reduced motion gets the finished state immediately: the sequence is
           the explanation, so hiding it would leave those readers with less
           information, not less movement. */
        if (reduce) { step = 3; paint(); return; }

        if (!onscreen) { pending = true; return; }

        t1 = setTimeout(function () { step = 2; paint(); }, BEAT_1);
        t2 = setTimeout(function () { step = 3; paint(); }, BEAT_1 + BEAT_2);
      }

      trigger.addEventListener('click', function () {
        open = true;
        material = 'drye';
        startSeq();
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          stopSeq();
          open = false;
          paint();
          trigger.focus();
        });
      }

      if (btnDrye) {
        btnDrye.addEventListener('click', function () {
          material = 'drye';
          startSeq();
        });
      }

      if (btnCotton) {
        btnCotton.addEventListener('click', function () {
          stopSeq();
          material = 'cotton';
          paint();
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            onscreen = e.isIntersecting;
            if (onscreen && pending) { pending = false; startSeq(); }
          });
        }, { threshold: 0.15 }).observe(root);
      } else {
        onscreen = true;
      }

      if (root.hasAttribute('data-drye-layers-open-default')) {
        open = true;
        startSeq();
      } else {
        paint();
      }
    });
  }

  window.DRYELayers = { init: function (scope) { layers(scope || document); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.DRYELayers.init(); });
  } else {
    window.DRYELayers.init();
  }

  /* Theme editor: sections are re-rendered without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    window.DRYELayers.init(e.target);
  });
})();
